import { createSlice } from '@reduxjs/toolkit';
import { fetchWaterTestParamsAsync, fetchWaterTestParamsAsyncBuilder } from './asyncRequests'

export interface AnalyteClass {
  _id?: string,
  name?: string,
  description?: string;
  analyte_parameters?: WaterTestParameter[]
}

export interface WaterTestParameter {
  _id: string;
  name: string;
  values: number[];
  measurement: string | null;
  category: string;
  colors: string[];
  allowable_range: number[] | null;
  label?: string;
  sort_value?: number;
  sdwa_contaminant_code?: string;
  group_name?: string;
  group_description?: string;
  analyte_class?: AnalyteClass;
}

export interface WaterTestParamsState {
  data: WaterTestParameter[]
  loading: boolean;
  success: boolean;
  error: string | null;
}

const initialState: WaterTestParamsState = {
  data: [],
  loading: false,
  success: false,
  error: null,

};

const waterTestParamsSlice = createSlice({
  name: 'waterTestParams',
  initialState,
  reducers: {
    toggleLoading : (state) => {
      state.loading = !state.loading;
    },
    resetForm: () => initialState,
  },
  extraReducers: (builder) => {
    fetchWaterTestParamsAsyncBuilder(builder);
  },
});


export const WaterTestParamsActions = {
  ...waterTestParamsSlice.actions,
  fetchWaterTestParamsAsync,

};
export const WaterTestParamsReducer =waterTestParamsSlice.reducer;